import {setTrackingDisabled} from '#services/storage'

export default function (state, payload) {
  setTrackingDisabled(payload.trackingDisabled)

  return {
    ...state,
    trackingDisabled: payload.trackingDisabled,
  }
}
